module.exports = __webpack_public_path__ + "img/si.31fbdc5b.svg";